module.exports = __webpack_public_path__ + "static/8-a548a988d1e2ba4c5aabc8429fb0712b.svg";